var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "" } },
        [
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "div1" }, [_vm._v("仓库管理")]),
          ]),
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "div2" }, [_vm._v("仓库库存")]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "nav" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "商品", name: "0" } },
                [
                  _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowForm,
                            expression: "isShowForm",
                          },
                        ],
                        staticClass: "query",
                      },
                      [
                        _c("div", { staticClass: "header" }, [
                          _c("span", [_vm._v("数据查询")]),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#409eff",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.isShowForm = false
                                },
                              },
                            },
                            [_vm._v(" 收起 ")]
                          ),
                        ]),
                        _c(
                          "el-form",
                          {
                            ref: "form",
                            attrs: {
                              "label-width": "70px",
                              inline: true,
                              model: _vm.queryFormGoods,
                              size: "mini",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "商品信息" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入商品编号/名称" },
                                  model: {
                                    value: _vm.queryFormGoods.info,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryFormGoods, "info", $$v)
                                    },
                                    expression: "queryFormGoods.info",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "formItem",
                                attrs: { label: "仓库名称" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择仓库名称",
                                    },
                                    on: { change: _vm.warSelect },
                                    model: {
                                      value: _vm.queryFormGoods.wareName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryFormGoods,
                                          "wareName",
                                          $$v
                                        )
                                      },
                                      expression: "queryFormGoods.wareName",
                                    },
                                  },
                                  _vm._l(_vm.wareData, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "formItem",
                                attrs: { label: "破损仓库" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "请选择破损仓库",
                                      "default-first-option": "",
                                    },
                                    model: {
                                      value: _vm.queryFormGoods.damagedWarId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryFormGoods,
                                          "damagedWarId",
                                          $$v
                                        )
                                      },
                                      expression: "queryFormGoods.damagedWarId",
                                    },
                                  },
                                  _vm._l(_vm.wareData1, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.damagedName,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "库位" } },
                              [
                                _vm.queryFormGoods.wareName
                                  ? _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.queryFormGoods.kw,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryFormGoods,
                                              "kw",
                                              $$v
                                            )
                                          },
                                          expression: "queryFormGoods.kw",
                                        },
                                      },
                                      _vm._l(_vm.options1, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.name,
                                          },
                                        })
                                      }),
                                      1
                                    )
                                  : _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.queryFormGoods.kw,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryFormGoods,
                                              "kw",
                                              $$v
                                            )
                                          },
                                          expression: "queryFormGoods.kw",
                                        },
                                      },
                                      _vm._l(_vm.options2, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.name,
                                            value: item.name,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "商品分类" } },
                              [
                                _c("el-cascader", {
                                  attrs: {
                                    options: _vm.options,
                                    props: {
                                      checkStrictly: true,
                                      label: "name",
                                      value: "id",
                                      children: "children",
                                    },
                                    filterable: "",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryFormGoods.clientType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryFormGoods,
                                        "clientType",
                                        $$v
                                      )
                                    },
                                    expression: "queryFormGoods.clientType",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "商品品牌" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "请选择商品品牌",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.queryFormGoods.bandName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryFormGoods,
                                          "bandName",
                                          $$v
                                        )
                                      },
                                      expression: "queryFormGoods.bandName",
                                    },
                                  },
                                  _vm._l(_vm.brandselect, function (items) {
                                    return _c("el-option", {
                                      key: items.id,
                                      attrs: {
                                        label: items.name,
                                        value: items.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: "上架与否" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "已上架",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.queryFormGoods.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryFormGoods,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "queryFormGoods.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "上架", value: "1" },
                                    }),
                                    _c("el-option", {
                                      attrs: { label: "下架", value: "0" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.searchEvent()
                                      },
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.searchEvent.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("搜索")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini" },
                                    on: { click: _vm.reset },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "buttonCont" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = true
                },
              },
            },
            [
              _vm._v(
                "已添加列表 (" +
                  _vm._s(
                    _vm.activeName == 0
                      ? _vm.cart.goodList.length
                      : _vm.cart.giftList.length
                  ) +
                  ")"
              ),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.addCart },
            },
            [_vm._v("批量添加")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.goodsExport },
            },
            [_vm._v("导出")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isShowForm,
                  expression: "!isShowForm",
                },
              ],
              staticStyle: { position: "absolute", right: "10px" },
              attrs: { type: "primary", size: "mini" },
              on: {
                click: function ($event) {
                  _vm.isShowForm = true
                },
              },
            },
            [_vm._v("搜索展开")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tableContext" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData.list },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { label: "序号", type: "index", width: "60" },
              }),
              _c("el-table-column", {
                attrs: { label: "图片", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.image
                          ? _c("img", {
                              staticStyle: { width: "70px", height: "70px" },
                              attrs: { src: props.row.image, alt: "" },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "上下架状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.status == 1 ? "上架" : "下架") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "code", label: "编号", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sku", label: "sku", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  label: "名称",
                  "min-width": "200",
                  "show-overflow": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "a",
                          {
                            staticStyle: { cursor: "pointer" },
                            attrs: { target: "_blank" },
                            on: {
                              click: function ($event) {
                                return _vm.goodsDetail(props.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(props.row.title))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌" },
              }),
              _c("el-table-column", {
                attrs: { prop: "typeName", label: "分类", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "wareName", label: "仓库", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "库位", prop: "storageLocationNames" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sellPrice", label: "单价" },
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "availableStock", label: "实际库存" },
              }),
              _c("el-table-column", {
                attrs: { prop: "quantityStock", label: "累计入库" },
              }),
              _c("el-table-column", {
                attrs: { prop: "skuStock", label: "sku库存" },
              }),
              _c("el-table-column", {
                attrs: { prop: "quantityReturn", label: "退货库存" },
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _vm.parArray.indexOf("aloneAddCart") != -1
                          ? _c(
                              "span",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.addCartSign(props.row)
                                  },
                                },
                              },
                              [_vm._v("添加")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("aloneAddCart") != -1
                          ? _c(
                              "span",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.getPoWarList(props.row)
                                  },
                                },
                              },
                              [_vm._v("库位")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("recordCode") != -1
                          ? _c(
                              "span",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.toGoodsRecord(props.row)
                                  },
                                },
                              },
                              [_vm._v("记录")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": "",
            withHeader: false,
            visible: _vm.dialogVisible,
            size: "60%",
            direction: "rtl",
          },
          on: {
            closed: function ($event) {
              _vm.value = ""
            },
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "border-bottom": "1px solid #dfdfdf",
                padding: "10px 0px 10px 10px",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-close",
                staticStyle: { color: "#d6d6d6", cursor: "pointer" },
                on: {
                  click: function ($event) {
                    _vm.dialogVisible = false
                  },
                },
              }),
              _c("span", { staticStyle: { "padding-left": "10px" } }, [
                _vm._v(" 已添加列表 "),
              ]),
            ]
          ),
          _c("div", { staticStyle: { overflow: "auto" } }, [
            _c(
              "div",
              { staticClass: "tableContext1" },
              [
                _c(
                  "el-table",
                  {
                    ref: "multipleTableCart",
                    attrs: {
                      stripe: "",
                      data:
                        _vm.activeName == 0
                          ? _vm.cart.goodList
                          : _vm.cart.giftList,
                    },
                    on: {
                      "selection-change": _vm.handleSelectionChangeCart,
                      "row-click": _vm.rowClick,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "50" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "序号", type: "index", width: "80" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "商品信息", prop: "title" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "SKU", prop: "sku" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "实际库存", prop: "availableStock" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "累计入库", prop: "quantityStock" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "SKU库存", prop: "skuStock" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "入库仓库" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return _vm._l(
                              scope.row.warehouses,
                              function (item) {
                                return _c("div", { key: item.id }, [
                                  _vm._v(" " + _vm._s(item.warName) + " "),
                                ])
                              }
                            )
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#f78d90",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteCart(scope.row.id)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticStyle: { height: "50px" } }),
            _c(
              "div",
              { staticClass: "action" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "danger" },
                    on: { click: _vm.moreDelect },
                  },
                  [_vm._v("批量删除")]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      right: "0",
                      bottom: "10px",
                      "padding-right": "10px",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini", placeholder: "请选择" },
                        model: {
                          value: _vm.value,
                          callback: function ($$v) {
                            _vm.value = $$v
                          },
                          expression: "value",
                        },
                      },
                      _vm._l(_vm.formButton, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.toFormButtonUrl },
                      },
                      [_vm._v("添加表单")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("div", { staticStyle: { height: "50px" } }),
      _vm.tableData.totalNum > 0
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage1,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "库位修改",
            visible: _vm.showKw,
            "append-to-body": "",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showKw = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "kwContext" },
            [
              _c("div", [_vm._v("当前库位")]),
              _c(
                "div",
                {
                  staticStyle: {
                    border: "1px solid #d8dce5",
                    padding: "8px 12px",
                    "border-radius": "5px",
                    background: "#eee",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.kwData.storageLocationNames
                          ? _vm.kwData.storageLocationNames
                          : "没有库位"
                      ) +
                      " "
                  ),
                ]
              ),
              _c("div", [_vm._v("修改库位")]),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { multiple: "" },
                  model: {
                    value: _vm.kwData.ids,
                    callback: function ($$v) {
                      _vm.$set(_vm.kwData, "ids", $$v)
                    },
                    expression: "kwData.ids",
                  },
                },
                _vm._l(_vm.options4, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showKw = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.updateKw } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }